import { ReactNode } from "react"
import { Box } from "theme-ui"
export interface TableRowProps {
 name: string
 value: string | ReactNode
 borderUnset?: boolean
}

export const TableRow = ({ name, value, borderUnset }: TableRowProps) => {
 return (
  <Box
   bg="highlight"
   color="text-black"
   className={`flex w-full justify-between py-3 px-5  ${
    borderUnset ? "border-b-0" : "border-b-[1.5px] border-light-gray"
   }`}
  >
   <h1 className="font-semibold w-[50%]">{name}:</h1>
   <h1 className="font-medium w-[50%]">{value}</h1>
  </Box>
 )
}
